import { Form, Formik } from 'formik';
import React, { useEffect } from 'react';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import Input from '../../../Components/Input/Input';
import ajclWhiteLogo from "../../../images/ajcl_logo_white.png";
import { forgotPassword } from '../../../Redux/Action/Auth';
import { errorNotify, successNotify } from '../../../Utils/Toast';
import { forgotPasswordSchema } from '../../../Utils/Validations';
import { getUserDetail } from '../../../Utils/Helper';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { loading, forgotApiData, error } = useSelector((state) => state.forgotAuth);

  useEffect(() => {
      const token = localStorage.getItem('tmsToken');
      if (token) {
        if (getUserDetail()?.role === 'user') {
          navigate('/dashboard/interested-tenders');
        }
        else {
          navigate('/dashboard');
        }
      }
    }, [navigate]);

  useEffect(() => {
    if (forgotApiData?.statusCode === 200) {
      successNotify("Recovery email sent successfully!");
      navigate('/');
      dispatch({ type: "FORGOT_PASSWORD_RESET" });
    }
    else if (error) {
      errorNotify(error);
      dispatch({ type: "FORGOT_PASSWORD_RESET" });
    }
  }, [forgotApiData, error]);

  return (
    <div className='login_wrapper'>
      <Container fluid>
        <Row>
          <Col md={6} className='login_left_side'>
            <div>
              <img src={ajclWhiteLogo} alt="logo" className='main_logo' />
              <h1>Tender Management System</h1>
            </div>
          </Col>
          <Col md={6} className='login_right_side'>
            <div className='login_form_wrapper'>
              <div className='login_form_heading'>
                <h2>Recover Password</h2>
                <p>Enter your email to receive recovery instructions.</p>
              </div>

              <Formik
                initialValues={{ email: '' }}
                validationSchema={forgotPasswordSchema}
                onSubmit={(values) => {
                  dispatch(forgotPassword({ email: values.email }));
                }}>
                {() => (
                  <Form>
                    <div className='login_form_fields'>
                      <Input
                        type="email"
                        name="email"
                        placeholder="Enter your email"
                        label="Email"
                      />
                      <button
                        type="submit"
                        disabled={loading}
                        className='login_btn mt-3'
                      >
                        {loading ? <Spinner animation='border' size='sm' /> : 'Send Recovery Email'}
                      </button>
                    </div>
                    <div className='auth_links mt-3'>
                      <p>Remember your password? <Link to="/">Login</Link></p>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ForgotPassword;